import { FC } from 'react';
import { twJoin, twMerge } from 'tailwind-merge';

import { Heading } from '@/components';
import { ProductItemPropTypes, LayoutTypes } from '@/components/Card/Product';
import { PRODUCT_LAYOUT_ENUMS } from '@/constants';
import CheckoutProductCard from '@/components/Card/CheckoutProduct';
import ProductCard from '@/components/Card/Product';
type ClassesTypes = {
  root?: string;
};

interface PropTypes {
  label?: string;
  classes?: ClassesTypes;
  items?: ProductItemPropTypes[];
  layout?: LayoutTypes;
}

const CartProductItem: FC<PropTypes> = ({
  label,
  items,
  layout = PRODUCT_LAYOUT_ENUMS.summary,
  classes,
}) => {
  return (
    <div
      aria-label='list'
      className={twMerge(`space-y-3 px-3 mb-2`, classes?.root)}>
      <Heading
        as='h4'
        className='p-0 text-xs font-semibold text-[#a1a0a1] md:text-sm mb-2 text-left'>
        {label}
      </Heading>

      {items?.map((el: ProductItemPropTypes, index: number) => (
        <div
          className={twJoin(
            `rounded-lg`,
            layout === PRODUCT_LAYOUT_ENUMS.summary
              ? 'bg-white'
              : 'bg-white  py-3'
          )}
          key={el?.item_id}>
          {layout === PRODUCT_LAYOUT_ENUMS.summary ? (
            <CheckoutProductCard item={{ ...el }} layout={layout} />
          ) : (
            <ProductCard item={{ ...el }} layout={layout} />
          )}
          {index !== items?.length - 1 &&
            layout === PRODUCT_LAYOUT_ENUMS.summary && (
              <div className='mt-2 border-t ml-0' />
            )}
        </div>
      ))}
    </div>
  );
};

export default CartProductItem;
